export var DISMISSAL_TYPE_SESSION = 'session';
export var DISMISSAL_TYPE_LOCAL_STORAGE = 'local_storage';
export var DISMISSAL_TYPE_DISABLED = 'disabled';
export var TIMED_ELEMENT_STORAGE_KEY = 'fisherman__timedElement';